import { React, useEffect, useState, useMemo } from "react";
import { getUsers, getList } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, ADMIN_ROLE, ENDPOINTS } from "../../Constants";
import { getEncryptedUserData } from "../../services/Utils";
import { Badge, Spinner } from "reactstrap";
import { Table, Button } from "reactstrap";
import { FaTimes, FaEdit, FaPlus, FaLock, FaSearch } from "react-icons/fa";

import {CreateUsers, SendPassword, UpdateAccountStatus, UpdateUsers, updateUserApi, listServiceAccountsApi, createServiceAccountApi, regenerateServiceAccountSecretApi} from  "../../services/Api";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

const filterUsersBySearch = (list, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return list;
  return list.filter((user) => {
    const haystack = [
      user.name,
      user.email,
      user.gender,
      user.telephone,
      user.role_name,
      user.country_name,
      user.created_at,
      user.updated_at,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(term);
  });
};


const UPLOAD_USER_COLUMNS = [
  { name: "name", description: "Full name of the user" },
  { name: "email", description: "User email address" },
  { name: "telephone", description: "User telephone number" },
];

const Users = (props) => {
  const currentUser = getEncryptedUserData();
  const isAdmin =
    currentUser &&
    (parseInt(currentUser.role, 10) === ADMIN_ROLE || currentUser.role === ADMIN_ROLE);
  //Hooks for the Create new Users action
  const [createModal, setcreateModal] = useState(false)
  const [uploadModal, setuploadModal] = useState(false)
  const [editModal, setEditModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({ name: "", email: "", role: 1, active: 1 });
  const [isSavingUser, setIsSavingUser] = useState(false);
  const [serviceAccountsModal, setServiceAccountsModal] = useState(false)
  const [serviceAccounts, setServiceAccounts] = useState([])
  const [isLoadingServiceAccounts, setIsLoadingServiceAccounts] = useState(false)
  const [showCreateServiceAccount, setShowCreateServiceAccount] = useState(false)
  const [newServiceAccountName, setNewServiceAccountName] = useState("")
  const [newServiceAccountDescription, setNewServiceAccountDescription] = useState("")
  const [isCreatingServiceAccount, setIsCreatingServiceAccount] = useState(false)
  const [showSecretModal, setShowSecretModal] = useState(false)
  const [regeneratedSecretData, setRegeneratedSecretData] = useState(null)
  const [regeneratingAccountId, setRegeneratingAccountId] = useState(null)
  const toggle = () => setcreateModal(!createModal);
  const uploadtoggle = () => setuploadModal(!uploadModal);
  const toggleServiceAccountsModal = () => {
    setServiceAccountsModal(!serviceAccountsModal);
    if (!serviceAccountsModal) {
      fetchServiceAccounts();
    } else {
      setShowCreateServiceAccount(false);
      setNewServiceAccountName("");
      setNewServiceAccountDescription("");
    }
  };


  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState("active");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedActiveUserIds, setSelectedActiveUserIds] = useState([]);
  const [bulkDeactivateModal, setBulkDeactivateModal] = useState(false);
  const [isBulkDeactivating, setIsBulkDeactivating] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);

  const editRoleOptions = useMemo(() => {
    const options = roleOptions.map((role) => ({
      value: role.value ?? role.id,
      label: role.text || role.role_name,
    }));
    if (
      editingUser &&
      !options.some((option) => String(option.value) === String(editingUser.role))
    ) {
      options.push({
        value: editingUser.role,
        label: editingUser.role_name || `Role ${editingUser.role}`,
      });
    }
    return options;
  }, [roleOptions, editingUser]);

  const activeUsers = useMemo(() => users.filter((u) => u.active === 1), [users]);
  const inactiveUsers = useMemo(() => users.filter((u) => u.active !== 1), [users]);
  const displayedActiveUsers = useMemo(
    () => filterUsersBySearch(activeUsers, searchTerm),
    [activeUsers, searchTerm]
  );
  const displayedInactiveUsers = useMemo(
    () => filterUsersBySearch(inactiveUsers, searchTerm),
    [inactiveUsers, searchTerm]
  );

  useEffect(() => {
    listUsers();
    listRoles();
    return () => { };
  }, []);

  const listRoles = async () => {
    setIsLoadingRoles(true);
    const roles = await getList(ENDPOINTS.LIST_ROLES);
    setRoleOptions(Array.isArray(roles) ? roles : []);
    setIsLoadingRoles(false);
  };

  useEffect(() => {
    if (activeTab !== "active") {
      setSelectedActiveUserIds([]);
    }
  }, [activeTab]);

  // useEffect(() => {
  //   fetchUsers(); // Fetch users on component mount
  // }, []);


//File upload hook
const [file, setFile] = useState(null);


// Hook declarations and handling functionalities on send password and active status
const [sendPasswordModal, setSendPasswordModal] = useState(false);
  const [statusChangeModal, setStatusChangeModal] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedID, setSelectedID] = useState('');
  const [selectedName, setSelectedName] = useState(null); 

  const [isActivating, setIsActivating] = useState(false);

  const toggleSendPasswordModal = () => setSendPasswordModal(!sendPasswordModal);
  const toggleStatusChangeModal = () => setStatusChangeModal(!statusChangeModal);

  const handleSendPassword = (email) => {
    setSelectedEmail(email);
    toggleSendPasswordModal();
  };

  const handleStatusChange = (email, isActivating, id, name) => {
    setSelectedEmail(email);
    setSelectedID(id)
    setIsActivating(isActivating);
    toggleStatusChangeModal();
    setSelectedName(name)
  };

  const confirmSendPassword = () => {
    toggleSendPasswordModal();
    // Call the function to send the password here
    sendPasswordComponent(selectedEmail);
    console.log(`Password sent to: ${selectedEmail}`);
  };

  const toggleEditModal = () => {
    setEditModal((prev) => {
      if (prev) {
        setEditingUser(null);
      }
      return !prev;
    });
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setEditForm({
      name: user.name || "",
      email: user.email || "",
      role: user.role,
      active: user.active,
    });
    setEditModal(true);
  };

  const handleEditFormChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdateUser = (e) => {
    e.preventDefault();
    if (!editingUser) return;

    const payload = {
      user_id: editingUser.id,
      name: editForm.name.trim(),
      email: editForm.email.trim(),
      role: parseInt(editForm.role, 10),
      active: parseInt(editForm.active, 10),
    };

    setIsSavingUser(true);
    updateUserApi(payload)
      .then((res) => {
        setIsSavingUser(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            cogoToast.success("User updated successfully");
            toggleEditModal();
            setActiveTab(payload.active === 1 ? "active" : "inactive");
            listUsers();
          } else {
            cogoToast.error(res.data.message || "Failed to update user");
          }
        }
      })
      .catch((err) => {
        setIsSavingUser(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again.");
      });
  };

  const confirmStatusChange = () => {
    toggleStatusChangeModal();
    const data = {
      id: selectedID,
      status: isActivating ? 1 : 0,
      name: selectedName,
    };
    statusChange(data);
  };

  const toggleActiveUserSelection = (userId) => {
    setSelectedActiveUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const toggleSelectAllVisibleActive = (userList) => {
    const visibleIds = userList.map((user) => user.id).filter(Boolean);
    const allSelected =
      visibleIds.length > 0 && visibleIds.every((id) => selectedActiveUserIds.includes(id));

    if (allSelected) {
      setSelectedActiveUserIds((prev) => prev.filter((id) => !visibleIds.includes(id)));
      return;
    }

    setSelectedActiveUserIds((prev) => Array.from(new Set([...prev, ...visibleIds])));
  };

  const confirmBulkDeactivate = () => {
    if (selectedActiveUserIds.length === 0) return;

    const payload = selectedActiveUserIds.map((id) => ({ id, status: 0 }));
    setIsBulkDeactivating(true);

    UpdateAccountStatus(payload)
      .then((res) => {
        setIsBulkDeactivating(false);
        if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
          const results = res.data.data?.results || [];
          const successCount = results.filter((item) => item.status === SUCCESS_RESULT).length;
          const failCount = results.length - successCount;

          if (failCount > 0) {
            cogoToast.warn(`${successCount} user(s) deactivated, ${failCount} failed`);
          } else {
            cogoToast.success(`${successCount || selectedActiveUserIds.length} user(s) deactivated successfully`);
          }

          setBulkDeactivateModal(false);
          setSelectedActiveUserIds([]);
          setActiveTab("inactive");
          listUsers();
          return;
        }

        cogoToast.error(res.data?.message || "Failed to deactivate users");
      })
      .catch((err) => {
        setIsBulkDeactivating(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again.");
      });
  };

  const statusChange = (data) => {
    setIsLoading(true);

    UpdateAccountStatus([{ id: data.id, status: data.status }])
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            const results = res.data.data?.results || [];
            const failed = results.find((item) => item.status !== SUCCESS_RESULT);
            if (failed) {
              setIsLoading(false);
              cogoToast.error(failed.message || "Failed to update user status");
              return;
            }

            setIsLoading(false);
            cogoToast.success(`${data.status === 1 ? "Activated" : "Deactivated"} user: ${data.name}`);
            setActiveTab(data.status === 1 ? "active" : "inactive");
            setSelectedActiveUserIds((prev) => prev.filter((id) => id !== data.id));
            listUsers();
          } else {
            setIsLoading(false);
            cogoToast.error(res.data.message);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again.");
      });
  };
  




  // const processedUsers = users.map(user => {
  //   const emailMatch = user.text.match(/<(.+)>/);
  //   const email = emailMatch ? emailMatch[1].trim() : ''; // Extract and trim the email
  //   const name = user.text.replace(/<.+>/, '').trim(); // Extract and trim the name
  //   return { ...user, email, name };
  // });

  // const fetchUsers = () => {
  //   // Replace with your API call to fetch users
  //   listUsers()
  //     .then((response) => {
  //       setRowData(response.data); // Assuming response.data contains the list of users
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       cogoToast.error('Failed to fetch users.');
  //       setIsLoading(false);
  //     });
  // };
    


  
  const listUsers = () => {
    setIsLoading(true);



    getUsers()
      .then((res) => {
        setIsLoading(false);
        // console.log("response is here");
        if (res.status == 200) {
          // console.log(res);

          if (res.data.status == SUCCESS_RESULT) {
            const userList = res.data.data || [];
            localStorage.setItem("users", JSON.stringify(userList));
            setUsers(userList);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {});
      });
  };

  // Service Accounts Functions
  const fetchServiceAccounts = () => {
    setIsLoadingServiceAccounts(true);
    listServiceAccountsApi({})
      .then((res) => {
        setIsLoadingServiceAccounts(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            setServiceAccounts(res.data.data || []);
          } else {
            cogoToast.error(res.data.message || "Failed to fetch service accounts", {});
          }
        }
      })
      .catch((err) => {
        setIsLoadingServiceAccounts(false);
        console.error("Error fetching service accounts:", err);
        cogoToast.error("Something went wrong while fetching service accounts", {});
      });
  };

  const handleCreateServiceAccount = (e) => {
    e.preventDefault();
    if (!newServiceAccountName.trim()) {
      cogoToast.error("Service account name is required", {});
      return;
    }

    setIsCreatingServiceAccount(true);
    createServiceAccountApi({
      name: newServiceAccountName.trim(),
      description: newServiceAccountDescription.trim() || null
    })
      .then((res) => {
        setIsCreatingServiceAccount(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            cogoToast.success("Service account created successfully", {});
            setNewServiceAccountName("");
            setNewServiceAccountDescription("");
            setShowCreateServiceAccount(false);
            fetchServiceAccounts();
          } else {
            cogoToast.error(res.data.message || "Failed to create service account", {});
          }
        }
      })
      .catch((err) => {
        setIsCreatingServiceAccount(false);
        console.error("Error creating service account:", err);
        cogoToast.error("Something went wrong while creating service account", {});
      });
  };

  const handleRegenerateSecret = (accountId) => {
    setRegeneratingAccountId(accountId);
    regenerateServiceAccountSecretApi({ id: accountId })
      .then((res) => {
        setRegeneratingAccountId(null);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            setRegeneratedSecretData(res.data.data);
            setShowSecretModal(true);
            fetchServiceAccounts(); // Refresh the list
          } else {
            cogoToast.error(res.data.message || "Failed to regenerate secret", {});
          }
        }
      })
      .catch((err) => {
        setRegeneratingAccountId(null);
        console.error("Error regenerating secret:", err);
        cogoToast.error("Something went wrong while regenerating secret", {});
      });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      cogoToast.success("Copied to clipboard!", {});
    }).catch(() => {
      cogoToast.error("Failed to copy to clipboard", {});
    });
  };

// Create New User Account Component

const createComponent =  (e) => {
  e?.preventDefault(); 
let data={
  

  "name":e.target.name.value,
  "email":e.target.email.value,
  "telephone":e.target.telephone.value,

  
}


setIsLoading(true);
console.clear();
console.log(data);
 
CreateUsers(data)
    .then((res) => {
      setcreateModal(false);
      setIsLoading(false);
      console.log(res);

      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setIsLoading(false);
          cogoToast.success("User was Created  successfully", {});
          setActiveTab("active");
          listUsers();
        } else {
          setIsLoading(false);
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. ", {});
    });
}


// Upload Component
// 
  

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    
    // setError('')
  };

  const handleUpload = () => {
    if (!file) {
      cogoToast.error("There is no file selected.", {});
      return
    }
    const formData = new FormData();
    formData.append("users", file);
    UpdateUsers(formData)
        .then((res) => {
          if (res.status === 200) {
              cogoToast.success(res.data.message, {});
              setFile(null);
              uploadtoggle();
              listUsers();
          }
        })
        .catch((err) => {
          console.error(err);
          cogoToast.error("Something went wrong, please try again.", {});
        });
    // const reader = new FileReader();
    // reader.onload = (e) => {
    //   const arrayBuffer = e.target.result;
    //   const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    //   const sheetName = workbook.SheetNames[0];
    //   const worksheet = workbook.Sheets[sheetName];
    //   const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    //   if (data.length === 0) {
    //     cogoToast.error("The file is empty or cannot be read.", {});
    //     return
    //   }

    //   const headers = data[0];
    //   const requiredHeaders = ['name', 'email', 'telephone'];
    //   const isValidHeaders = requiredHeaders.every(header => headers.includes(header));
    //   const hasExtraColumns = headers.length !== requiredHeaders.length;

    //   if (!isValidHeaders) {
    //     cogoToast.error('The file must contain columns: name, email, and telephone.');
    //     return
    //   }

    //   if (hasExtraColumns) {
    //     cogoToast.error('The file contains extra columns. Only name, email, and telephone are allowed.');
    //     return
    //   }

    //   const jsonData = XLSX.utils.sheet_to_json(worksheet);

    //   // Assuming UpdateUsers is an async function that returns a promise
      
    // };

    // reader.readAsArrayBuffer(file);
  };
    
    
// Send Password functionality
const isUserAdminRole = (user) =>
  parseInt(user.role, 10) === ADMIN_ROLE || user.role === ADMIN_ROLE;

const renderUserRole = (user) => {
  const label = user.role_name || "—";
  if (isUserAdminRole(user)) {
    return (
      <Badge color="primary" pill style={{ fontSize: "0.85rem", padding: "0.45em 0.75em" }}>
        {label}
      </Badge>
    );
  }
  return label;
};

const renderUserActions = (user) => {
  const isActive = user.active === 1;
  const statusIcon = isActive ? "fa fa-check-circle" : "fa fa-check-circle";

  return (
    <span className="text-nowrap">
      {isAdmin && (
        <>
          <Button
            className="badge btn-info"
            onClick={() => handleEditUser(user)}
            title="Edit user"
          >
            <FaEdit style={{ color: "white", cursor: "pointer" }} />
          </Button>
          &nbsp;&nbsp;
        </>
      )}
      <Button
        className="badge btn-primary"
        onClick={() => handleSendPassword(user.email)}
        title="Send password"
      >
        <i className="fa fa-key" aria-hidden="true"></i>
      </Button>
      &nbsp;&nbsp;
      <Button
        className="badge btn-warning"
        onClick={() => handleStatusChange(user.email, user.active === 0, user.id, user.name)}
        title={isActive ? "Deactivate user" : "Activate user"}
      >
        <i className={statusIcon}></i>
      </Button>
    </span>
  );
};

const renderUserTable = (userList, showCheckboxes = false) => {
  const visibleIds = userList.map((user) => user.id).filter(Boolean);
  const allVisibleSelected =
    showCheckboxes &&
    visibleIds.length > 0 &&
    visibleIds.every((id) => selectedActiveUserIds.includes(id));
  const columnCount = showCheckboxes ? 11 : 10;

  return (
  <div className="table-responsive">
    <Table striped bordered hover className="mb-0">
      <thead>
        <tr>
          {showCheckboxes && (
            <th style={{ width: 40 }}>
              <input
                type="checkbox"
                checked={allVisibleSelected}
                onChange={() => toggleSelectAllVisibleActive(userList)}
                title="Select all visible users"
              />
            </th>
          )}
          <th style={{ width: 60 }}>#</th>
          <th>User Name</th>
          <th>User Email</th>
          <th>Gender</th>
          <th>Telephone</th>
          <th>User Role</th>
          <th>Country</th>
          <th>Date Created</th>
          <th>Date Updated</th>
          <th style={{ width: isAdmin ? 150 : 110 }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {userList.length === 0 ? (
          <tr>
            <td colSpan={columnCount} className="text-center text-muted py-4">
              {searchTerm.trim() ? "No users match your search." : "No users found."}
            </td>
          </tr>
        ) : (
          userList.map((user, index) => (
            <tr key={user.id || `${user.email}-${index}`}>
              {showCheckboxes && (
                <td>
                  <input
                    type="checkbox"
                    checked={selectedActiveUserIds.includes(user.id)}
                    onChange={() => toggleActiveUserSelection(user.id)}
                  />
                </td>
              )}
              <td>{index + 1}</td>
              <td>{user.name || "—"}</td>
              <td>{user.email || "—"}</td>
              <td>{user.gender || "—"}</td>
              <td>{user.telephone || "—"}</td>
              <td>{renderUserRole(user)}</td>
              <td>{user.country_name || "—"}</td>
              <td>{user.created_at || "—"}</td>
              <td>{user.updated_at || "—"}</td>
              <td>{renderUserActions(user)}</td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  </div>
  );
};

const sendPasswordComponent =  (email) => {
  // Implement the logic to send the password to the email.
  // console.log(`Sending password to ${email}`);
  // e?.preventDefault();
setIsLoading(true);
console.clear();
console.log(email);
 
let data={
  
  "email":email,

  
}
SendPassword(data)
    .then((res) => {
      // setcreateModal(false);
      setIsLoading(true);
      console.log(res);

      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setIsLoading(false);

          
          cogoToast.success("Password has sent successfully", {});
          listUsers();
        } else {
          setIsLoading(false);
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. ", {});
    });
}




  return (
    <div>
        <div className="card-body">
  <div className="d-flex justify-content-between align-items-center">
  <h1>User Management</h1>

      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div> 
      <div className="d-flex justify-content-between">
      <div className="w-50 p-1">
      <Button
        className="btn btn-info w-100"
        onClick={() => {
          setuploadModal(true);
        }}
      >
        + Upload Users
      </Button>
    </div>


    <div className="w-50 p-1">
      <Button
        className="btn btn-info w-100"
        onClick={() => {
          setcreateModal(true);
        }}
      >
        + Add New User
      </Button>
    </div>

        
      </div>
      <div className="d-flex justify-content-end mt-2">
        <Button
          className="btn btn-secondary"
          onClick={toggleServiceAccountsModal}
        >
          Manage Service Accounts
        </Button>
      </div>
  </div>
  {/* The rest of your component code goes here */}
</div>
      

<Modal
        isOpen={createModal}
        
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             Add New User
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      
{/* {JSON.stringify(components)}   */}
<form onSubmit={createComponent}>
  <div className="row">
    {/* First Row: User Name and Email */}
    <div className="col-md-6">
      User Name
      <input className="form-control" name="name" required={true} />
    </div>

    <div className="col-md-6">
      Email
      <input className="form-control" name="email" required={true} />
    </div>
  </div>

  <div className="row mt-3">
    {/* Second Row: Telephone and Submit Button */}
    <div className="col-md-6">
      Telephone
      <input className="form-control" name="telephone" required={true} />
    </div>

    <div className="col-md-6 d-flex align-items-end">
      {!isLoading ? (
        <input type="submit" className="btn btn-primary w-100" value="Create User" />
      ) : (
        <button className="btn btn-primary w-100" disabled={true}>
          <Spinner /> &nbsp; Processing..
        </button>
      )}
    </div>
  </div>
</form>
        </ModalBody>
      
      </Modal>


      <Modal
        isOpen={uploadModal}
        
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={uploadtoggle}>
          <div className="row">
             Upload Users 
          </div>
           
          
         </ModalHeader>
        <ModalBody>
          <div className="alert alert-info mb-3" role="alert">
            <strong>Expected Excel columns</strong>
            <p className="mb-2 mt-2">
              The first row must contain these column headers exactly. Do not include extra columns.
            </p>
            <ul className="mb-0 pl-3">
              {UPLOAD_USER_COLUMNS.map((column) => (
                <li key={column.name}>
                  <code>{column.name}</code> — {column.description}
                </li>
              ))}
            </ul>
          </div>

  <div className="row">
    <div className="mb-3 col-12">
      <label className="form-label">Excel file (.xlsx, .xls)</label>
      <input type="file" className="form-control" accept=".xlsx,.xls,.csv" onChange={handleFileChange} />
    </div>

    <div className="col-md-6 d-flex align-items-center">
      {!isLoading ? (
        <input type="submit" className="btn btn-primary w-100"  value="Upload Users" onClick={handleUpload} />
      ) : (
        <button className="btn btn-primary w-100" disabled={true}>
          <Spinner /> &nbsp; Processing..
        </button>
         )}
        <div className="modal-footer">
        
      </div>
     
    </div>
  </div>
        </ModalBody>
      
      </Modal>

    
      
<div className="card-body">
        <div className="mb-3">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FaSearch />
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search by name, email, telephone, role, country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm.trim() && (
              <div className="input-group-append">
                <Button color="secondary" onClick={() => setSearchTerm("")}>
                  Clear
                </Button>
              </div>
            )}
          </div>
        </div>

        <ul className="nav nav-tabs mb-3" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              type="button"
              className={`nav-link ${activeTab === "active" ? "active" : ""}`}
              onClick={() => setActiveTab("active")}
              role="tab"
            >
              Active Users
              <Badge color="success" className="ml-2">
                {displayedActiveUsers.length}
                {searchTerm.trim() && activeUsers.length !== displayedActiveUsers.length
                  ? ` / ${activeUsers.length}`
                  : ""}
              </Badge>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              type="button"
              className={`nav-link ${activeTab === "inactive" ? "active" : ""}`}
              onClick={() => setActiveTab("inactive")}
              role="tab"
            >
              Inactive Users
              <Badge color="secondary" className="ml-2">
                {displayedInactiveUsers.length}
                {searchTerm.trim() && inactiveUsers.length !== displayedInactiveUsers.length
                  ? ` / ${inactiveUsers.length}`
                  : ""}
              </Badge>
            </button>
          </li>
        </ul>

        {activeTab === "active" && selectedActiveUserIds.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light border rounded">
            <span>
              {selectedActiveUserIds.length} user{selectedActiveUserIds.length === 1 ? "" : "s"} selected
            </span>
            <div>
              <Button
                color="secondary"
                className="mr-2"
                onClick={() => setSelectedActiveUserIds([])}
                disabled={isBulkDeactivating}
              >
                Clear selection
              </Button>
              <Button
                color="warning"
                onClick={() => setBulkDeactivateModal(true)}
                disabled={isBulkDeactivating}
              >
                {isBulkDeactivating ? (
                  <>
                    <Spinner size="sm" className="mr-2" />
                    Deactivating...
                  </>
                ) : (
                  "Deactivate"
                )}
              </Button>
            </div>
          </div>
        )}

        <div className="tab-content">
          {activeTab === "active"
            ? renderUserTable(displayedActiveUsers, true)
            : renderUserTable(displayedInactiveUsers)}
        </div>

             {/* Bulk Deactivate Confirmation Modal */}
             <Modal isOpen={bulkDeactivateModal} toggle={() => setBulkDeactivateModal(false)}>
        <ModalHeader toggle={() => setBulkDeactivateModal(false)}>Deactivate Users</ModalHeader>
        <ModalBody>
          Deactivate {selectedActiveUserIds.length} selected user
          {selectedActiveUserIds.length === 1 ? "" : "s"}?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setBulkDeactivateModal(false)} disabled={isBulkDeactivating}>
            Cancel
          </Button>
          <Button color="warning" onClick={confirmBulkDeactivate} disabled={isBulkDeactivating}>
            {isBulkDeactivating ? "Deactivating..." : "Deactivate"}
          </Button>
        </ModalFooter>
      </Modal>

             {/* Send Password Confirmation Modal */}
             <Modal isOpen={sendPasswordModal} toggle={toggleSendPasswordModal}>
        <ModalHeader toggle={toggleSendPasswordModal}>Send Password</ModalHeader>
        <ModalBody>
          Do you wish to send the password to {selectedEmail}?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleSendPasswordModal}>
            No
          </Button>
          <Button color="primary" onClick={confirmSendPassword}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit User Modal */}
      <Modal isOpen={editModal} toggle={toggleEditModal} backdrop={true}>
        <ModalHeader toggle={toggleEditModal}>Edit User</ModalHeader>
        <ModalBody>
          <form onSubmit={handleUpdateUser}>
            <div className="form-group">
              <label>Name</label>
              <input
                className="form-control"
                value={editForm.name}
                onChange={(e) => handleEditFormChange("name", e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                value={editForm.email}
                onChange={(e) => handleEditFormChange("email", e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>User Role</label>
              <select
                className="form-control"
                value={editForm.role}
                onChange={(e) => handleEditFormChange("role", e.target.value)}
                required
                disabled={isLoadingRoles}
              >
                {isLoadingRoles ? (
                  <option value="">Loading roles...</option>
                ) : editRoleOptions.length === 0 ? (
                  <option value="">No roles available</option>
                ) : (
                  editRoleOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="form-group mt-3">
              <label>Status</label>
              <select
                className="form-control"
                value={editForm.active}
                onChange={(e) => handleEditFormChange("active", e.target.value)}
                required
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
            <div className="mt-4 d-flex justify-content-end">
              <Button color="secondary" className="mr-2" onClick={toggleEditModal} type="button">
                Cancel
              </Button>
              {isSavingUser ? (
                <Button color="primary" disabled>
                  <Spinner size="sm" className="mr-2" />
                  Saving...
                </Button>
              ) : (
                <Button color="primary" type="submit">
                  Save Changes
                </Button>
              )}
            </div>
          </form>
        </ModalBody>
      </Modal>

      {/* Status Change Confirmation Modal */}
      <Modal isOpen={statusChangeModal} toggle={toggleStatusChangeModal}>
        <ModalHeader toggle={toggleStatusChangeModal}>
          {isActivating ? 'Activate User' : 'Deactivate User'}
        </ModalHeader>
        <ModalBody>
          Do you want to {isActivating ? 'activate' : 'deactivate'} {selectedEmail}?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleStatusChangeModal}>
            No
          </Button>
          <Button color="primary" onClick={confirmStatusChange}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      {/* Service Accounts Modal */}
      <Modal isOpen={serviceAccountsModal} toggle={toggleServiceAccountsModal} size="lg">
        <ModalHeader toggle={toggleServiceAccountsModal}>
          Manage Service Accounts
        </ModalHeader>
        <ModalBody>
          {!showCreateServiceAccount ? (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Service Accounts</h5>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setShowCreateServiceAccount(true)}
                >
                  <FaPlus /> Create New Service Account
                </Button>
              </div>

              {isLoadingServiceAccounts ? (
                <div className="text-center py-4">
                  <Spinner />
                </div>
              ) : serviceAccounts.length === 0 ? (
                <div className="text-center py-4 text-muted">
                  No service accounts found
                </div>
              ) : (
                <div className="table-responsive">
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>API Key</th>
                        <th>Status</th>
                        <th>Last Used</th>
                        <th>Expires At</th>
                        <th>Created By</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {serviceAccounts.map((account) => (
                        <tr key={account.id}>
                          <td>{account.name || "-"}</td>
                          <td>{account.description || "-"}</td>
                          <td>
                            <code style={{ fontSize: "0.85em" }}>
                              {account.api_key ? `${account.api_key.substring(0, 20)}...` : "-"}
                            </code>
                          </td>
                          <td>
                            <Badge color={account.is_active ? "success" : "secondary"}>
                              {account.is_active ? "Active" : "Inactive"}
                            </Badge>
                          </td>
                          <td>{account.last_used_at ? new Date(account.last_used_at).toLocaleString() : "Never"}</td>
                          <td>{account.expires_at ? new Date(account.expires_at).toLocaleDateString() : "Never"}</td>
                          <td>
                            {account.created_by ? (
                              <div>
                                <div>{account.created_by.name || "-"}</div>
                                <small className="text-muted">{account.created_by.email || ""}</small>
                              </div>
                            ) : "-"}
                          </td>
                          <td>{account.created_at ? new Date(account.created_at).toLocaleString() : "-"}</td>
                          <td>
                            <Button
                              color="warning"
                              size="sm"
                              onClick={() => handleRegenerateSecret(account.id)}
                              disabled={regeneratingAccountId !== null}
                            >
                              {regeneratingAccountId === account.id ? (
                                <>
                                  <Spinner size="sm" className="mr-1" />
                                  Regenerating...
                                </>
                              ) : (
                                <>
                                  <FaLock className="mr-1" />
                                  Regenerate Secret
                                </>
                              )}
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </>
          ) : (
            <div>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Create New Service Account</h5>
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => {
                    setShowCreateServiceAccount(false);
                    setNewServiceAccountName("");
                    setNewServiceAccountDescription("");
                  }}
                >
                  <FaTimes /> Cancel
                </Button>
              </div>

              <form onSubmit={handleCreateServiceAccount}>
                <div className="form-group">
                  <label>Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={newServiceAccountName}
                    onChange={(e) => setNewServiceAccountName(e.target.value)}
                    placeholder="Enter service account name"
                    required
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={newServiceAccountDescription}
                    onChange={(e) => setNewServiceAccountDescription(e.target.value)}
                    placeholder="Enter description (optional)"
                  />
                </div>

                <div className="mt-3">
                  {isCreatingServiceAccount ? (
                    <Button color="primary" disabled>
                      <Spinner size="sm" className="mr-2" />
                      Creating...
                    </Button>
                  ) : (
                    <Button type="submit" color="primary">
                      Create Service Account
                    </Button>
                  )}
                </div>
              </form>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleServiceAccountsModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Regenerated Secret Modal */}
      <Modal isOpen={showSecretModal} toggle={() => setShowSecretModal(false)} size="lg">
        <ModalHeader toggle={() => setShowSecretModal(false)}>
          New API Secret Generated
        </ModalHeader>
        <ModalBody>
          {regeneratedSecretData && (
            <div>
              <div className="alert alert-warning" role="alert">
                <strong>⚠️ IMPORTANT:</strong> {regeneratedSecretData.warning || "Save the new API secret now. The old secret is now invalid and this secret will not be shown again."}
              </div>

              <div className="form-group mt-3">
                <label><strong>API Key</strong> (unchanged)</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={regeneratedSecretData.api_key || ""}
                    readOnly
                    style={{ fontFamily: "monospace", backgroundColor: "#f8f9fa" }}
                  />
                  <div className="input-group-append">
                    <Button
                      color="secondary"
                      onClick={() => copyToClipboard(regeneratedSecretData.api_key)}
                    >
                      Copy
                    </Button>
                  </div>
                </div>
              </div>

              <div className="form-group mt-3">
                <label><strong>New API Secret</strong> <span className="text-danger">* Save this now!</span></label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={regeneratedSecretData.api_secret || ""}
                    readOnly
                    style={{ fontFamily: "monospace", backgroundColor: "#fff3cd", fontWeight: "bold" }}
                  />
                  <div className="input-group-append">
                    <Button
                      color="primary"
                      onClick={() => copyToClipboard(regeneratedSecretData.api_secret)}
                    >
                      Copy Secret
                    </Button>
                  </div>
                </div>
                <small className="text-muted">This secret will not be shown again. Make sure to save it securely.</small>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {
            setShowSecretModal(false);
            setRegeneratedSecretData(null);
          }}>
            I've Saved the Secret
          </Button>
        </ModalFooter>
      </Modal>
        </div>
    </div>
  );
};

export default Users;
